export default "__VITE_ASSET__21a5a2f2__"